import React, {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {logoutRequest} from 'util/api';
import 'styles/menu/LeftMenuBar.css';
import MenuLinks from './MenuLinks';
import AddMoneyPopupWrapper from 'components/donate/AddMoneyPopupWrapper';
import {usePopup} from 'popup/PopupContext';
import SignInPopup from 'components/login/SignInPopup';
import {UserContext} from '../user/UserContext';
import {WebSocketContext} from 'wss/WebSocketService';
import {centsToString} from 'util/cashFormatter';
import UniversalProfileImage from 'components/universal/UniversalProfileImage';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';

const LeftMenuBar = () => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const wsService = useContext(WebSocketContext);
    const {user, isCashTenant} = useContext(UserContext);
    const {openPopup} = usePopup();
    const profileRef = useRef(null);
    const {isDesktopView} = useSessionConfiguration();

    useEffect(() => {
        console.log('IsConnected: ', isConnected);
    }, [isConnected]);

    useEffect(() => {
        const handleConnected = () => setIsConnected(true);
        const handleDisconnected = () => setIsConnected(false);

        wsService.onConnected(handleConnected);
        wsService.onDisconnected(handleDisconnected);

        return () => {
            wsService.onConnectedCallbacks = wsService.onConnectedCallbacks.filter(cb => cb !== handleConnected);
            wsService.onDisconnectedCallbacks = wsService.onDisconnectedCallbacks.filter(cb => cb !== handleDisconnected);
        };
    }, [wsService]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [profileRef]);

    const handleProfileImageClick = () => {
        setShowDropdown(!showDropdown);
    };

    const handleLogout = async () => {
        try {
            await logoutRequest();
            localStorage.removeItem('isLoggedIn');
            navigate('/');
            window.location.reload();
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to logout. Please try again.');
        }
    };

    const handleSetProfileImageClick = () => {
        navigate('/profile/edit');
        setShowDropdown(false);
    };

    const handleTransactionsClick = () => {
        navigate('/history');
        setShowDropdown(false);
    };

    const handleSwagClick = () => {
        navigate('/swag');
        setShowDropdown(false);
    };

    const onBalanceClick = () => {
        openPopup(<AddMoneyPopupWrapper/>);
    };

    const onSignInClick = () => {
        openPopup(<SignInPopup/>, () => {
        }, true);
    };

    return (
        <div className="floating-bar-wrapper">
            <div className={isDesktopView ? 'floating-bar' : 'horizontal-menu'}>
                <div className="menu-logo-container">
                    <img
                        src={isCashTenant ? "/nametext/Flextagram.svg" : "/nametext/Flexagren.svg"}
                        alt="Logo"
                        onClick={() => navigate('/')}
                        className="cursor-pointer menu-logo-text"
                    />
                </div>
                <MenuLinks/>
                <div className="user-section position-relative" ref={profileRef}>
                    {user.isLoggedIn ? (
                        <>
                            <span className="username">{user.username}</span>
                            <span className="balance" id={'balance-amount'} data-testid="desktop-user-balance"
                                  onClick={onBalanceClick}>
                                <span className="balance-text">Balance</span>
                                <span className="balance-text balance-amount">
                                    {user.balance === null ? '...' : centsToString(user.balance)}
                                </span>
                            </span>
                            <div onClick={handleProfileImageClick}>
                                <UniversalProfileImage id={user.profileImage} cssClass={'user-icon'}/>
                            </div>
                            {showDropdown && (
                                <div className="profile-settings">
                                    <div className="profile-setting-option" onClick={handleSwagClick}>
                                        Swag
                                    </div>
                                    <div className="profile-setting-separator"/>
                                    <div className="profile-setting-option" onClick={handleSetProfileImageClick}>
                                        Set Profile
                                    </div>
                                    <div className="profile-setting-separator"/>
                                    <div className="profile-setting-option" onClick={handleTransactionsClick}>
                                        History
                                    </div>
                                    <div className="profile-setting-separator"/>
                                    <div className="profile-setting-option" onClick={handleLogout}>
                                        Logout
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <label className="sign-in-label" onClick={onSignInClick}>
                            SIGN IN
                        </label>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LeftMenuBar;